import * as ko from 'knockout'
import template from './multselection.pricing.tpl.html'
import { MultiSelectionPriceViewModel, Params } from './MultiSelectionPriceViewModel'

if (!ko.components.isRegistered('multiselection-pricing')) {
  ko.components.register('multiselection-pricing', {
    viewModel: {
      createViewModel: (params: Params) => {
        const viewModel = new MultiSelectionPriceViewModel(params)
        return viewModel
      },
    },
    template,
  })
}
